import e,{createElement as o,useState as t,useEffect as r,useCallback as n,useMemo as i}from"react";import{setup as l,styled as d}from"goober";import{shouldForwardProp as a}from"goober/should-forward-prop";function s(){return(s=Object.assign||function(e){for(var o=1;o<arguments.length;o++){var t=arguments[o];for(var r in t)Object.prototype.hasOwnProperty.call(t,r)&&(e[r]=t[r])}return e}).apply(this,arguments)}let c,p,u,b,g=e=>e;const f=["fontSize","fontColor","selectedFontColor","optionsAmount","optionBorderRadius","isRawText","selectedIndex","border","backgroundColor","selectedBackgroundColor","wrapperBorderRadius","selectionIndicatorMargin","disabled"];l(o,void 0,void 0,a(e=>!f.includes(e)));const h=d("div")(c||(c=g`
    display: flex;
    border-radius: ${0};
    border: ${0};
    background: ${0};
    width: 100%;
    height: 100%;
    position: relative;
    opacity: ${0};
    overflow: hidden;

    &::before {
        top: 50%;
        left: ${0}%;
        content: "";
        position: absolute;
        height: calc(100% - ${0}px);
        width: calc(
            ${0}%${0}${0}px
        );
        border-radius: ${0};
        border: ${0}px ${0}${0};
        background: ${0};
        transition:
            left 0.1s linear,
            background 0.1s linear;
        transform: translateY(-50%);
        z-index: 1;
        box-sizing: content-box;
    }
`),({wrapperBorderRadius:e})=>"number"==typeof e?`${e}px`:e,e=>e.border,e=>e.backgroundColor,e=>e.disabled?.7:1,e=>e.selectedIndex/e.optionsAmount*100,e=>2*e.selectionIndicatorMargin,e=>1/e.optionsAmount*100," - ",e=>2*e.selectionIndicatorMargin,({optionBorderRadius:e})=>"number"==typeof e?`${e}px`:e,e=>e.selectionIndicatorMargin,"solid ",e=>e.backgroundColor,e=>e.selectedBackgroundColor),C=d("div")(p||(p=g`
    display: flex;
    align-items: center;
    height: 100%;
    width: ${0}%;
    border-radius: ${0};
`),e=>1/e.optionsAmount*100,({optionBorderRadius:e})=>"number"==typeof e?`${e}px`:e),m=d("label")(u||(u=g`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    z-index: 2;
    transition: color 0.1s linear;
    cursor: ${0};
    font-size: ${0};
    color: ${0};
`),e=>e.disabled?"not-allowed":"pointer",e=>e.isRawText?e.fontSize+"px":"unset",e=>e.isRawText?e.selected?e.selectedFontColor:e.fontColor:"unset"),x=d("input")(b||(b=g`
    width: 0;
    height: 0;
    opacity: 0;
    z-index: -1;
    position: absolute;
    pointer-events: none;
`)),$={backgroundColor:"#ecf0f1",selectedBackgroundColor:"#2ecc71",fontColor:"#000",selectedFontColor:"#fff"};export default o=>{var l;const{onChange:d=(()=>{}),options:a=[],initialSelectedIndex:c=0}=o,p=!!a[c],[u,b]=t(p?c:0),{border:g=0,backgroundColor:f=$.backgroundColor,selectedBackgroundColor:w=$.selectedBackgroundColor,wrapperBorderRadius:k=20,optionBorderRadius:B=18,fontSize:y=14,fontColor:v=$.fontColor,selectedFontColor:R=$.selectedFontColor,selectionIndicatorMargin:I=2,forcedSelectedIndex:z,disabled:F=!1,name:A}=o;r(()=>{void 0!==z&&a[z]&&z!==u&&b(z)},[z,a,u]);const M=n(e=>{F||e===u||(b(e),d(a[e].value))},[F,d,a,u]),S=i(()=>a.map((o,t)=>{const r=u===t,n=`${null!=A?A:"rss"}-option-${t}`,i="string"==typeof o.label;return e.createElement(C,{key:n,optionsAmount:a.length,className:"react-switch-selector-option react-switch-selector-option-"+(r?"selected":"unselected"),optionBorderRadius:B},e.createElement(m,s({className:"react-switch-selector-option-label",selected:r,isRawText:i,disabled:F,"aria-disabled":F,htmlFor:n},i?{fontSize:y,fontColor:o.fontColor||v,selectedFontColor:o.selectedFontColor||R}:{}),e.createElement(x,{type:"radio",id:n,name:A,onChange:()=>M(t),checked:r,"aria-checked":r,tabIndex:r?0:-1}),o.label))}),[F,v,y,M,A,B,a,R,u]);return a.length?e.createElement(h,{selectedIndex:u,optionsAmount:a.length,className:"react-switch-selector-wrapper "+(F?"react-switch-selector-disabled":""),border:g,backgroundColor:f,selectedBackgroundColor:(null==(l=a[u])?void 0:l.selectedBackgroundColor)||w,wrapperBorderRadius:k,optionBorderRadius:B,selectionIndicatorMargin:I,disabled:F,role:"radiogroup","aria-labelledby":A},S):null};
//# sourceMappingURL=index.modern.js.map
